"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Warnings = void 0;

var _immutable = require("immutable");

var _constants = require("./constants");

var Warnings = {
  userAccountExpired: {
    use: 'danger',
    message: 'expired'
  },
  userAccountWillExpire: {
    use: 'warning',
    message: 'warning'
  },
  accountMissingPermissions: {
    use: 'danger',
    message: 'missingPermissions'
  }
};
exports.Warnings = Warnings;

var missingPermissions = function missingPermissions(user) {
  var requiredPermissions = _constants.REQUIRED_APP_PERMISSIONS[user.network];

  if (!requiredPermissions) {
    return [];
  }

  return requiredPermissions.filter(function (permission) {
    return !user.appScopes.includes(permission);
  });
};

var _getWarningLevel = function getWarningLevel(user, permissionsType) {
  if (user.network === 'FACEBOOK' || user.network === 'LINKEDIN') {
    if (!user.authenticated) {
      return Warnings.userAccountExpired;
    }

    var missing = missingPermissions(user);

    if (missing.length) {
      if (!permissionsType || _constants.MissingPermissionTypesForNetwork[permissionsType][user.network].filter(function (permission) {
        return missing.includes(permission);
      }).length) {
        return Warnings.accountMissingPermissions;
      }
    }

    if (user.expiringSoon) {
      return Warnings.userAccountWillExpire;
    }
  }

  return null;
};

var _default = (0, _immutable.Record)({
  appScopes: null,
  userId: null,
  userName: null,
  hubSpotUserId: null,
  authenticated: null,
  connectedAt: null,
  network: null,
  expiringSoon: null,
  expiresAt: null,
  getWarningLevel: function getWarningLevel() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var permissionsType = opts.permissionsType;
    return _getWarningLevel(this, permissionsType);
  }
});

exports.default = _default;